import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Edit from '@mui/icons-material/Edit';
import { useParams } from 'react-router-dom';
import { updateClient } from 'src/store/actions/clientActions';
import useStyles from '../styles';
import ClientContactInfo from './ClientContactInfo';
import PhysicalClientContactDetailDialog from './ClientContactDetailDialog/PhysicalClient';
import { PersonType } from '../../../../utils/constants/clients';
import LegalClientContactDetailDialog from './ClientContactDetailDialog/LegalClient/index';

const ClientContactDetail = ({ client, isDisabledEdit }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleSubmit = useCallback(
    values => {
      dispatch(updateClient(id, values, () => handleClose()));
    },
    [client, dispatch]
  );

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('CLIENTS_VIEW.CLIENT_DETAIL.CLIENT_CONTACT_DETAIL')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <ClientContactInfo client={client} />
          </TableBody>
        </Table>
        {client.personType === PersonType.PHYSICAL ? (
          <PhysicalClientContactDetailDialog
            open={open}
            client={client}
            handleClose={handleClose}
            submit={handleSubmit}
          />
        ) : (
          <LegalClientContactDetailDialog
            open={open}
            client={client}
            handleClose={handleClose}
            submit={handleSubmit}
          />
        )}

        <Grid container direction="column" alignItems="stretch">
          <Grid item className={classes.buttons}>
            <Button
              disabled={isDisabledEdit}
              onClick={handleClickOpen}
              variant="contained"
              color="primary"
              className={clsx(classes.label, classes.buttons)}
              startIcon={<Edit />}
            >
              {t('COMMON.EDIT')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ClientContactDetail.propTypes = {
  client: PropTypes.object.isRequired,
  isDisabledEdit: PropTypes.bool
};

export default ClientContactDetail;
